export default __webpack_public_path__ + "static/media/image-6.1911916e.png";